import {
  Close,
  Home,
  MailOutline,
  Person,
  PowerSettingsNew,
  Search,
  Settings,
  ShoppingCart,
  StarOutline,
  WebAsset,
} from '@mui/icons-material';
import { Box, Hidden, IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import Gene20Menu from '../../../Components/Gene20Menu';
import Gene20Typography from '../../../Components/Gene20Typography';
import { NotificationProvider } from '../../../context/contexts/NotificationContext';
import { toogleSearch } from '../../../redux/reducers/searchSlice';
import { topBarHeight } from '../../../utils/constant';
import FadeMenu from '../../popupMenu/PopUpMenu';
import Gene20NotificationBar from './Gene20NotificationBar';
import ProfileMenu from './profileMenu';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const TopbarRoot = styled('div')(({ theme }) => ({
  top: 0,
  zIndex: 96,
  transition: 'all 0.3s ease',
  //   boxShadow: themeShadows[8],
  height: topBarHeight,
}));

const TopbarContainer = styled(Box)(({ theme }) => ({
  padding: '8px',
  paddingLeft: 18,
  paddingRight: 20,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  [theme.breakpoints.down('xs')]: {
    paddingLeft: 14,
    paddingRight: 16,
  },
}));

const UserMenu = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: 24,
  padding: 4,
  '& span': { margin: '0 8px' },
}));
const IconBox = styled('div')(({ theme }) => ({
  display: 'inherit',
  [theme.breakpoints.down('md')]: { display: 'none !important' },
}));
const StyledItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 185,
  '& a': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  '& span': { marginRight: '10px', color: theme.palette.text.primary },
}));
export default function AppBarContent() {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.theme.darkMode);
  const isOpen = useSelector((state) => state.menu.isOpen);
  const auntheticated = useSelector((state) => state.aunth.auntheticated);
  const openSearch = useSelector((state) => state.search.openSearch);
  const SearchIcon = () => {
    return (
      <IconButton onClick={() => dispatch(toogleSearch())}>
        <Search />
      </IconButton>
    );
  };
  const SearchBar = () => {
    return (
      <Gene20Box sx={{ width: '50vw' }}>
        <TextField
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                <Search />
              </InputAdornment>
            ),
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{ cursor: 'pointer' }}
                onClick={() => dispatch(toogleSearch())}
              >
                <Close fontSize="smaller" />
              </InputAdornment>
            ),
          }}
          color="secondary"
          placeholder="search "
          variant="standard"
        />
      </Gene20Box>
    );
  };
  const SearchComponent = () => {
    return <Gene20Box>{openSearch ? <SearchBar /> : <SearchIcon />}</Gene20Box>;
  };
  return (
    <Gene20Box display="flex">
      <Gene20Box display="flex" alignItems="center">
        <SearchComponent />
        <Gene20Box sx={{ display: !openSearch ? 'flex' : 'none' }}>
          {/* <NotificationProvider> */}
          <Gene20NotificationBar />
          {/* </NotificationProvider> */}
          <IconButton>
            <ShoppingCart />
          </IconButton>
          <ProfileMenu />
        </Gene20Box>
      </Gene20Box>
    </Gene20Box>
  );
}
